// INPUT
export const inputTypes = {
  text: "text",
  password: "password",
  number: "number",
  date: "date",
};

export type InputTypes = keyof typeof inputTypes;

// SELECT
export interface OptionTypes {
  value: string | number;
  label: string | number;
}

// BUTTON
export const buttonTypes = {
  submit: "submit",
  button: "button",
};

export type ButtonTypes = keyof typeof buttonTypes;

export const buttonVariants = {
  Primary: "bg-chatlook-darkblue text-ev-white",
  Transaparent: "bg-chatlook-grey !border-[#B7B7B7] !text-[#B7B7B7] clear-btn",
  secondary: "bg-[#afadad] text-ev-white",
  Default: "",
};
export type ButtonVariants = keyof typeof buttonVariants;

export const getButtonVariants = (variant: ButtonVariants) =>
  buttonVariants?.[variant] || buttonVariants["Default"];

// STATUS
export const statusTypes = {
  Success: "Success",
  success: "success",
  Pending: "Pending",
  pending: "pending",
  Failed: "Failed",
  Processing: "Processing",
  Expired: "Expired",
  Initialized: "Initialized",
  INITIALIZED: "INITIALIZED",
  initialized: "initialized",
  All: "All",
  "Not Attempted": "Not Attempted",
  Default: "Default",
};

export const statusStyles: typeof statusTypes = {
  Success: "bg-green-100 text-green-700",
  success: "bg-green-100 text-green-700",
  Pending: "bg-blue-100 text-blue-700",
  pending: "bg-blue-100 text-blue-700",
  Failed: "bg-red-100 text-red-700",
  Processing: "bg-purple-100 text-purple-700",
  Expired: "bg-orange-100 text-orange-700",
  Initialized: "bg-yellow-100 text-yellow-700",
  INITIALIZED: "bg-yellow-100 text-yellow-700",
  initialized: "bg-yellow-100 text-yellow-700",
  All: "bg-pink-100 text-pink-700",
  "Not Attempted": "bg-amber-100 text-amber-700",
  Default: "bg-gray-100 text-gray-700",
};
export type StatusTypes = keyof typeof statusTypes;

export const getStatusTypes = (type: StatusTypes) =>
  `${statusStyles?.[type] || statusStyles.Default} px-2 py-1 rounded text-xs inline-block whitespace-nowrap`;

// TOASTER
export const toasterTypes = {
  Success: "Success",
  Error: "Error",
};

export type ToasterTypes = keyof typeof toasterTypes;
